var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiBtn',_vm._b({attrs:{"color":_vm.color,"size":_vm.size,"icon":"common/headphone","text":_vm.c_text},on:{"click":function($event){return _vm.$store.dispatch('globalModal/open_globalModalSupport')}}},'UiBtn',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }